import { FREIGABESTATUS_KUNDENFREIGABE_OFFEN } from '@/constants/prozesskontrollkarte/freigabestatus';
import prozesskontrollkarteStatus from '@/static/prozesskontrollkarte/prozesskontrollkarteStatus';

import {
  lager, lagerPlatz, anzahlTeile, klassifizierung, werkstoff, mengeAuftrag, mengeneinheit,
} from '@/config/fertigungsauftrag/fertigungsAuftragFields';
import {
  ABRUESTEN, EINRICHTERFREIGABE, FINISHED, GESTOPPT,
  IN_PRODUKTION,
} from '@/constants/protocol/protocolstatus.type';

export default [
  {
    path: 'prozesskontrollkarte',
    component: () => import('@/layouts/prozesskontrollkarte/Prozesskontrollkarte.vue'),
    children: [
      {
        name: 'prozesskontrollkarte',
        path: '',
        component: () => import('@/views/prozesskontrollkarte/ProzesskontrollkarteStartseite.vue'),
      },
      {
        name: 'fertigungsauftrag',
        path: 'fertigungsauftrag',
        component: () => import('@/layouts/prozesskontrollkarte/Fertigungsauftrag.vue'),
        children: [
          {
            name: 'fertigungsauftrag.liste',
            path: 'liste',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/FertigungsauftragListe.vue'),
            props: {
              title: 'Fertigungsaufträge',
              additionalFields: [
                klassifizierung,
                werkstoff,
                mengeAuftrag,
                mengeneinheit,
              ],
            },
          },
          {
            name: 'fertigungsauftrag.liste.kundenfreigabe_offen',
            path: 'liste/kundenfreigabe-offen',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/FertigungsauftragListe.vue'),
            props: {
              freigabestatus: FREIGABESTATUS_KUNDENFREIGABE_OFFEN,
              title: 'Infra - Kundenfreigabe',
              additionalFields: [
                klassifizierung,
                werkstoff,
                mengeAuftrag,
                mengeneinheit,
              ],
            },
          },
          {
            name: 'fertigungsauftrag.liste.auf_sperrlager',
            path: 'liste/auf-sperrlager',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/FertigungsauftragListe.vue'),
            props: {
              title: 'Fertigungsaufträge auf Sperrlager',
              sperrlager: true,
              additionalFields: [
                lager,
                lagerPlatz,
                anzahlTeile,
              ],
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste',
            path: 'prozesskontrollkarte',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.abgeschlossen',
            path: 'prozesskontrollkarte/abgeschlossen',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              status: FINISHED,
              title: 'Abgeschlossene Prozesskontrollkarten',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.aktuell',
            path: 'prozesskontrollkarte/aktuell',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              notStatus: FINISHED,
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.error',
            path: 'prozesskontrollkarte/error',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              /**
               * Mail von Fr. Wlotzka 26.02.26: In den Fehlerhaften PCKs sollen auch die abgeschlossenen PCKs angezeigt werden, bei denen es Fehler gab. Daher wird hier nicht nach Status gefiltert, sondern nur nach Fehlern
               */
              // notStatus: FINISHED,
              error: true,
              title: 'Fehlerhafte aktuelle PCKs',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.einrichterfreigabe',
            path: 'prozesskontrollkarte/einrichterfreigabe',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              notStatus: FINISHED,
              status: `${EINRICHTERFREIGABE},${GESTOPPT}`,
              title: 'Prozesskontrollkarten - Einrichterfreigabe',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.in_produktion',
            path: 'prozesskontrollkarte/in-produktion',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              notStatus: FINISHED,
              status: `${IN_PRODUKTION}`,
              title: 'Prozesskontrollkarten - In Produktion',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.abruesten',
            path: 'prozesskontrollkarte/abruesten',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              notStatus: FINISHED,
              status: `${ABRUESTEN}`,
              title: 'Prozesskontrollkarten -  Abrüstbereit',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.farbpruefung',
            path: 'prozesskontrollkarte/farbpruefung',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              farbpruefung: true,
              status: FINISHED,
              title: 'FAs mit Farbprüfung',
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.liste.dokumente_kontrollieren',
            path: 'prozesskontrollkarte/dokumente-kontrollieren',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkartenliste.vue'),
            props: {
              status: FINISHED,
              title: 'PCKs mit Begleitdokumenten',
              dokumenteKontrolliert: false,
            },
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.id',
            path: 'prozesskontrollkarte/:id',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkarte.vue'),
            props: true,
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.id.edit',
            path: 'prozesskontrollkarte/:id/edit',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/Prozesskontrollkarte.vue'),
            props: (route) => ({
              id: route.params.id,
              edit: true,
            }),
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.id.druckmessung',
            path: 'prozesskontrollkarte/:id/druckmessung/:edit',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/ProzesskontrollkarteDruckmessung.vue'),
            props: true,
          },
          {
            name: 'fertigungsauftrag.prozesskontrollkarte.id.spcauswertung',
            path: 'prozesskontrollkarte/:id/spc-auswertung/:edit',
            component: () => import('@/views/prozesskontrollkarte/fertigungsuaftrag/prozesskontrollkarte/ProzesskontrollkarteSpcAuswertung.vue'),
            props: true,
          },
        ],
      },
      {
        path: 'admin',
        component: () => import('@/layouts/prozesskontrollkarte/ProzesskontrollkarteAdmin.vue'),
        children: [
          {
            name: 'prozesskontrollkarteliste.admin',
            path: 'list',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkartenliste.vue'),
          },
          {
            name: 'prozesskontrollkarteliste.admin.fehlende_funktionspruefungen',
            path: 'list/fehlende-funktionspruefungen',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkartenliste.vue'),
            props: {
              title: 'PCKs mit fehlenden Funktionsprüfungen',
              fehlendeFunktionspruefungen: true,
            },
          },
          {
            name: 'prozesskontrollkarteliste.admin.entwuerfe',
            path: 'list/entwuerfe',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkartenliste.vue'),
            props: {
              title: 'Prozesskontrollkarten - Entwürfe',
              status: prozesskontrollkarteStatus.entwurf,
            },
          },
          {
            path: 'prozesskontrollkarte/neu',
            name: 'prozesskontrollkarte.admin.neu',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkarte.vue'),
            props: {
              id: null,
              edit: true,
            },
          },
          {
            path: 'prozesskontrollkarte/:id',
            name: 'prozesskontrollkarte.admin.id',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkarte.vue'),
            props: true,
          },
          {
            path: 'prozesskontrollkarte/:id/edit',
            name: 'prozesskontrollkarte.admin.id.edit',
            component: () => import('@/views/prozesskontrollkarte/admin/Prozesskontrollkarte.vue'),
            props: (route) => ({
              edit: true,
              id: route.params.id,
            }),
          },
          {
            path: 'fertigungsauftrag/ohne_pck',
            name: 'prozesskontrollkarte.fertigungsauftrag.ohne_pck',
            component: () => import('@/views/prozesskontrollkarte/admin/FertigungsauftragListeOhnePck.vue'),
            props: true,
          },
        ],
      },
    ],
  },
];
